module.exports = __webpack_public_path__ + "pc/media/PC_about_time_lapse.614e24d3.webm";